<script setup lang="ts">
import type { Schemas } from '#shopware'
import { handleScrollAndClick } from '~/utils/handle-scroll-and-click'

const props = defineProps<{
    content: Schemas['CmsElementLinkButton']
}>()

const config = computed(() => props.content?.config)

const _daisyUIClasses = 'btn-ghost btn-link btn-outline btn-active btn-disabled glass no-animation btn-lg btn-md btn-sm btn-xs btn-wide btn-block btn-circle btn-square'

const horizontalAlignmentStyles = computed(() => {
    switch (config.value?.horizontalAlign?.value) {
    case 'center': return 'text-center'
    case 'left': return 'text-left'
    case 'right': return 'text-right'
    default: return ''
    }
})

const buttonType = computed(() => {
    switch (config.value?.buttonType?.value) {
    case 'neutral': return 'btn-neutral'
    case 'primary': return 'btn-primary'
    case 'secondary': return 'btn-secondary'
    case 'accent': return 'btn-accent'
    default: return ''
    }
})
</script>

<template>
    <div class="w-full" :class="horizontalAlignmentStyles">
        <MiscLink
            :to="config?.anchorTarget?.value"
            :target="config?.openInNewTab?.value ? '_blank' : null"
            :rel="config?.openInNewTab?.value ? 'noopener' : null"
            :class="`btn ${buttonType} ${config?.customStyles?.value ?? ''}`"
            @click="handleScrollAndClick($event, config?.anchorTarget?.value ?? '')"
        >
            <MiscIcon v-if="config?.showIcon?.value === 'before'" name="arrow-left" />
            {{ config?.buttonText?.value }}
            <MiscIcon v-if="config?.showIcon?.value === 'after'" name="arrow-right" />
        </MiscLink>
    </div>
</template>
